
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from 'react';
import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import star from './imgs/star.svg';
import s from './Sidebar.module.scss';
const TextRenderer = dynamic(import('@components/MarkDownIt'));
const propTypes = {
    text: PropTypes.string.isRequired
};
const Sidebar = ({ text }) => {
    return (<div className={s.root}>
      <div className={s.border}>
        <img src={star} alt="star"/>
        <hr />
        <img src={star} alt="star"/>
      </div>
      <div className={s.textContainer}>
        <TextRenderer text={text} Component={'div'}/>
      </div>
      <div className={s.border}>
        <img src={star} alt="star"/>
        <hr />
        <img src={star} alt="star"/>
      </div>
    </div>);
};
Sidebar.propTypes = propTypes;
export default Sidebar;

    async function __Next_Translate__getStaticProps__195ca0caf36__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'src//FactFile/components/Sidebar/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__195ca0caf36__ as getStaticProps }
  